import {svgIconWrapper} from '../svg-icon-wrapper';

import UservoiceRegular from './uservoice-regular-icon.svg';

function SvgComponent(props: React.SVGProps<SVGSVGElement>) {
    return <UservoiceRegular {...props} />;
}

SvgComponent.iconName = 'uservoiceRegular';

export const UservoiceRegularIcon = svgIconWrapper(SvgComponent);
